<template>
  <div>
    <el-dialog title="修改密码" width="500px" :visible.sync="dialogVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input placeholder="请输入原密码" v-model="ruleForm.oldPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input placeholder="请输入新密码" v-model="ruleForm.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input placeholder="请确认新密码" v-model="ruleForm.confirmPassword" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/************************
 * 修改密码弹窗
 * created by DJX on 2023-12-28
 ************************/
import * as api from '@/api/system.js'
export default {
  name: "ChangePassword",
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: '请输入原密码',
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(
                  new Error(
                    '请确认新密码'
                  )
                );
              } else {
                if (value !== this.ruleForm.newPassword) {
                  callback(
                    new Error(
                      '新密码两次输入不同，请重新输入'
                    )
                  );
                }
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 打开修改密码弹窗
     */
    openDialog() {
      this.dialogVisible = true;
      if (this.$refs["ruleForm"]) {
        // 清空表单
        this.$refs["ruleForm"].resetFields();
      }
    },

    /**
     * 确认修改密码
     */
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          api.resetUserPwd(this.ruleForm.oldPassword, this.ruleForm.newPassword).then(res => {
            console.log(res)
            this.$message.success("修改成功");
            localStorage.clear()
            setTimeout(() => {
              this.dialogVisible = false;
              this.$router.push("/login");
            }, 500)
          }).catch(err => {
            console.log(err)
            // this.$message.warning(err.data.msg);
          })
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style></style>